import React from 'react';
import PropTypes from 'prop-types';
import { LAYER_LEGENDS } from '../../../../lib/constants';
import styles from './LayerListItem.module.scss';

const LayerLegends = (props) => {
  const layerName = props.layer.layerName.toLowerCase();

  const LegendIcon = (iconProps) => {
    if ( iconProps.legend.color ) {
      return <iconProps.legend.icon color={iconProps.legend.color} />;
    }
    else {
      return <img src={iconProps.legend.icon} />;
    }
  };

  const legends = LAYER_LEGENDS[layerName];

  if (legends != null && !!props.layer.control.enabled) {
    return (
      <div className={styles.legends}>
        {legends.map((legend,i) => {
          return (
            <div key={i} className={styles.legendItem}>
              <div>
                <LegendIcon legend={legend} />
              </div>
              <div className={styles.legendName}>
                {legend.name}
              </div>
            </div>
          );
        })}
      </div>
    );
  }
  return null;
};

LayerLegends.propTypes = {
  layer: PropTypes.object
};

export default LayerLegends